import React from 'react';
import BarLine from '../common/graphs/barLineNew';

const Bar = props => (
  <div className={`main_summary_graph__color ${props.width}`}>
    <div className="tour-aux-light-area indicator-distribution-tour"/>
    <a className="normal" data-tags={false}>
      {props.distribution && (
        <BarLine
          name="type"
          value="value"
          distribution={props.distribution}
          language={props.language.summary.ffdPvt.graphTooltip}
        />
      )}
    </a>
    {props.text && (
      <div className="distribution-chart-info">
        <h3>{props.language.summary.ffdPvt[props.reportType].resultsDistribution}</h3>
        <div className="modal-indicators-info">
          <a className="green">
            <i className="fas fa-question-circle" />
            <div>            
              <p>{props.language.summary.ffdPvt[props.reportType].distHelp1}</p>
              {props.language.summary.ffdPvt[props.reportType].cat1Label && (
                <p>
                  <span className="green">
                  {props.language.summary.ffdPvt[props.reportType].cat1Label + ": "}
                  </span> 
                  {props.language.summary.ffdPvt[props.reportType].cat1}
                </p>
              )}
              {props.language.summary.ffdPvt[props.reportType].cat2Label && (
                <p>
                  <span className="yellow">
                  {props.language.summary.ffdPvt[props.reportType].cat2Label + ": "}
                  </span> 
                  {props.language.summary.ffdPvt[props.reportType].cat2}
                </p>
              )}
              {props.language.summary.ffdPvt[props.reportType].cat3Label && (
                <p>
                  <span className="red">
                  {props.language.summary.ffdPvt[props.reportType].cat3Label + ": "}
                  </span> 
                  {props.language.summary.ffdPvt[props.reportType].cat3}
                </p>
              )}
              {props.language.summary.ffdPvt[props.reportType].cat4Label && (
                <p>
                  <span className="purple">
                  {props.language.summary.ffdPvt[props.reportType].cat4Label + ": "}
                  </span> 
                  {props.language.summary.ffdPvt[props.reportType].cat4}
                </p>
              )}
            </div>
          </a>
        </div>
      </div>
    )}
  </div>
);

export default Bar;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_pvt/bar.jsx